import { object } from 'common/helpers'


export const initialState = {
  referrerData: {},
  products: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const setReferrerData = (state, payload) => (
  object.set(state, 'referrerData', payload)
)

export const setProducts = (state, payload) => (
  object.set(state, 'products', payload)
)
